/**
 * Firebase Configuration for Frontend
 *
 * Uses Vite environment variables for Firebase credentials.
 * These are loaded from FRONTEND/.env file.
 */

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID
};

// Validate config
const requiredKeys = ['apiKey', 'authDomain', 'projectId'];
const missingKeys = requiredKeys.filter(key => !firebaseConfig[key]);

if (missingKeys.length > 0) {
  console.error('[Firebase Config] Missing required configuration:', missingKeys);
  console.error('[Firebase Config] Make sure FRONTEND/.env has all VITE_FIREBASE_* variables');
}

export default firebaseConfig;
